query assuntoSelect($where: AssuntoModelFilterInput) {
    data: assuntos(where: $where, order: [{nome: ASC}]) {
        value: codigo
        label: nome
    }
}